import React, { useState, useEffect } from "react";
import Modal from "../../../component/Global/Modal";
import System from "../../../helper/system";
import { useQuoteDetailStore } from "src/hooks/quote-detail";
import QuoteDetail from "@system/config/quote-detail";
import { useDOMAttachToSystemStore } from "src/hooks/domAttachToSystem";
import { useCartStore } from "src/hooks/cart";
import { __remove, __set } from "src/store/axios_indicator";
import HelperAdobeEvent from "src/support/HelperAdobeEvent";
import { useProductPricingStore } from "src/hooks/productPricing";
import { useProductInventoryStore } from "src/hooks/productInventory";

const ClearCartPopup = (props) => {
  const [status, SetStatus] = useState(false);
  const [{ ClearCartPopup }, { }, { }] = useDOMAttachToSystemStore();
  const [
    { get_current_quote_cart },
    { },
    { destroy_cart_quote_active_session },
  ] = useQuoteDetailStore();
  const [{ CART_DATA }, { get_cart_quote_number }, { CLEAR_CART }] =
    useCartStore();
  const quoteList = get_current_quote_cart();
  const [, { get_inventory_by_id }, { }] = useProductInventoryStore();
  const [{ pricingList }, { }, { }] = useProductPricingStore();
  const quoteNumber = get_cart_quote_number();

  useEffect(() => {
    if (ClearCartPopup) {
      SetStatus(true);
    }
  }, [ClearCartPopup]);

  const onHide = (action = true) => {
    SetStatus(false);
  };

  const clearedAllCart = async () => {
    // Comment due to scrolling issue 8675
    // setTimeout(() => {
    // System.clearAllAlert();
    // }, 2000);

    if (quoteNumber) {
      destroy_cart_quote_active_session();
      clearQuoteCartEvent();
      // Redirection
      window.location.href = QuoteDetail.getQuoteDetailPageRouteURL({
        quote_number: quoteNumber,
      });
    } else {
      __set("CART_API_CALL");
      await CLEAR_CART();
      __remove("CART_API_CALL");
    }
    setTimeout(() => {
      System.clearAllAlert();
      if (!quoteNumber) {
        clearCartEvent();
      }
    }, 200);

    // new Cart().setCartCount({CART_COUNT: 0});
    // new Cart().setCartData({ CART_DATA: {}});
    onHide();
  };

  //By Ramya Kannan [Clear cart - Adobe script ]
  function clearCartEvent() {
    localStorage.setItem("adobeEventType", "cartRemovalEvent");
    let prodDetails = CART_DATA;
    if (Object.keys(prodDetails).length) {
      HelperAdobeEvent.trackingAdobeEvent({ prodDetails });
    }
  }

  function clearQuoteCartEvent() {
    let quoteDetails = [];
    let prodDetails = [];
    Object.entries(quoteList).map((data, key) => {
      quoteDetails.push(data[1]);
      prodDetails.push(data[1].product);
    })

    prodDetails.map((data, ind) => {
      let copyObj = { ...data };
      copyObj.qas = getInventory(data?.ERPPartNumber)?.qas;
      copyObj.subtotal = (quoteDetails[ind]?.subTotal_quantity_1);
      copyObj.unitPrice = quoteDetails[ind]?.price_quantity_1;
      copyObj.Quantity = quoteDetails[ind]?.quantity_0;
      copyObj.priceSource = getPricing(
        data.ERPMFRPartNumber || data.erpMfrPartNumber,
        data.ERPPartNumber,
        data.ERPPartNumberModified
      )[0]?.priceSource;
      copyObj.quoteID = quoteNumber;
      copyObj.quoteType = "online";
      prodDetails[ind] = copyObj;
    })

    let cartDetails = {
      additionSource: "PLP",
      cartType: "Quote",
      quoteID: quoteNumber,
      quoteType: "online",
    };
    localStorage.setItem("adobeEventType", "quoteCartRemovalEvent");

    if (Object.keys(prodDetails).length) {
      HelperAdobeEvent.trackingAdobeEvent({ prodDetails, cartDetails });
    }
  }

  const getInventory = (ERPPartNumber) => {
    return get_inventory_by_id(ERPPartNumber)
  };

  const getPricing = (
    ERPMFRPartNumber,
    ERPPartNumber,
    ERPPartNumberModified
  ) => {
    ERPPartNumber = ERPPartNumberModified ? "" : ERPPartNumber;
    if (pricingList[ERPMFRPartNumber + "-" + ERPPartNumber]) {
      return pricingList[ERPMFRPartNumber + "-" + ERPPartNumber];
    }
    return [];
  };

  return (
    <>
      <Modal
        show={status}
        onHide={() => {
          onHide();
        }}
      >
        <div className="avnet-modal modal-630">
          <div className="avnet-modal-inner">
            {/* Modal Header */}
            <button
              type="button"
              className="close py-3"
              data-dismiss="modal"
              onClick={() => {
                onHide();
              }}
            >
              ×
            </button>
            <div className="modal-header justify-content-center mt-0">
              <h3 className="pcn-modal-heading pl-5">Cart - Clear All</h3>
            </div>
            {/* Modal body */}
            <div className="modal-body py-0">
              <div className="clearfix" />
              <div className="text-center mt-3 mb-5">
                <p className="mb-0">
                  Clearing your cart is permanent. All items will be removed and
                  is not reversible.
                </p>
              </div>
            </div>
            {/* Modal footer */}
            <div className="modal-footer text-center">
              <div className="modal-footer-actions">
                <button
                  type="button"
                  className="bs5 btn btn-secondary btn-sm"
                  data-dismiss="modal"
                  onClick={() => {
                    onHide();
                  }}
                >
                  Cancel
                </button>
                <button
                  onClick={() => {
                    clearedAllCart();
                  }}
                  type="button"
                  className="bs5 btn btn-primary btn-sm w145"
                >
                  continue
                </button>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default ClearCartPopup;
